export default {
    PUBLICACAO: 'Compra publicada',
    DESPUBLICACAO: 'Compra Despublicada',
    SUSPENSAO: 'Processo suspenso',
    EXCLUSAO_PROPOSTAS: 'Propostas excluídas',
    PRORROGACAO: 'Compra Prorrogada',
    ANEXOS: 'Anexos atualizados',
    NOTIFICACAO: 'Notificação'
}
